<template>
<section class="page-gallery">
  <div class="qbk-header">
    <img src="../assets/images/logo-red.svg" alt="">
  </div>
  <div class="qbk-gallery-box">
    <div class="qbk-wrap">
      <div class="qbk-gallery-nav">
        <router-link v-for="(gal,index) in gallery" :key="'qbk-gal-title'+index" :to="`/gallery/${gal.id}`"><h4>{{gal.title}} <small>({{gal.child.length+1}})</small></h4></router-link>
      </div>
      <div class="qbk-gallery-main">
        <div class="row">
          <div v-for="(im,index) in gallery" :key="'qbk-gal-'+index">
            <router-link :to="`/gallery/${im.id}`">
                <img :src="im.image" alt="" class="img-fluid">
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import axios from 'axios'
import {baseUrl} from '../config'
export default {
  name: 'gallery',
  data() {
    return {
      gallery: []
    }
  },
  methods: {
    loadGallery() {
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage: '~',
        type: 'GALLERY ITEM'
      }
      axios
        .post(url, payload)
        .then((res) => {
          let data = res.data.data
          this.gallery = data
        })
        .catch((e) => {
          this.notif('Error', e.message, 'error')
        })
    },
  },
  mounted() {
      this.loadGallery()
  }
}
</script>
